/**
 * Recupera o primeiro valor encontrado que é do tipo 'string'
 * e possui um tamanho maior que zero. Caso não exista nenhum match
 * retornará o valor definido por 'retornoPadrao'
 * @param {*} retornoPadrao Retorno default caso nenhum valor atenda aos critérios
 * @param  {...any} valores 
 * @returns 
 */
export function recuperarPrimeiroValorComComprimento(
  retornoPadrao = "",
  ...valores
) {
  for (let i = 0; i < valores.length; i++) {
    const valor = valores[i];

    const possuiConteudo = typeof valor === "string" && valor.length > 0;

    if (possuiConteudo) {
      return valor;
    }
  }

  return retornoPadrao;
}
